<ng-container *ngIf="readonly; else currencyInput">
  {{
    model | number : currencySetting!.format | replaceNullWith : replaceNullWith
  }}
  <ng-container *ngIf="showCurrency && model">
    {{ currencySetting!.currency }}
  </ng-container>
</ng-container>
<ng-template #currencyInput>
  <div class="layout-box">
    <p-inputNumber
      sigvInputNumberSetting
      [maxFractionDigits]="digitInfo?.maxFraction"
      [minFractionDigits]="digitInfo?.minFraction"
      [numberOnly]="!digitInfo?.maxFraction && !digitInfo?.minFraction"
      [disabled]="disabled"
      [(ngModel)]="model"
      (ngModelChange)="onModelChange($event)"
      (onFocus)="focused.emit($event)"
      (onBlur)="blured.emit($event)"
      (onInput)="inputed.emit($event)"
    ></p-inputNumber>
    <ng-container *ngIf="showCurrency">
      <span class="currency-sign">{{ currencySetting!.currency }}</span>
    </ng-container>
  </div>
</ng-template>
